import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AdminListHostingByUserComponent from "../../../components/Admin/users/AdminListHostingByUserComponent";

const ListHostingByUserPage = () => {
    const params = useParams()
    const navigate = useNavigate();

    let redirect = () => {
        navigate('/admin/khach-hang');
    }

    return <AdminListHostingByUserComponent
        userId={ params.userId }
        shouldRedirect={ () => redirect() }
    />;
}

export default ListHostingByUserPage;